import React from "react";
import { Col, Row } from "react-bootstrap";
import CountUp from "react-countup";
import up from "../../../../assets/DigitalMarketing/image/dashboard/arrow_up.svg";
import down from "../../../../assets/DigitalMarketing/image/dashboard/arrow down.svg";
import { BsThreeDots } from "react-icons/bs";

function MimoCount(props) {
  const { CountList } = props;
  return (
    <Row className="Dashboard row-count">
        {CountList.map((a, i) => {
          return (
            <Col md={4} className="mt-2" key={i}>
              <div className="box-count">
                <div>
                  <div className="dash-detail">
                    <span className="f-16">{a.title}</span>
                    <br></br>
                    <span className="text-bold">
                      <CountUp end={a.list} duration={3} />
                    </span>
                  </div>
                  {/* {true ? (
                    <>
                      <img src={up} width={15} />
                      <small className="c-green"> +0.00.</small>
                    </>
                  ) : (
                    <>
                      <img src={down} />
                      <small className="c-red"> +0.00%.</small>
                    </>
                  )}
                  <small> vs Previous month</small> */}
                </div>
              </div>
            </Col>
          );
        })}
      </Row>
  );
}

export default React.memo(MimoCount);